import axios from "axios";
import S3Upload from "react-s3-uploader/s3upload";
import { getAccessToken } from "src/utils/authentication.service";
import {
  CreatePPTStoryboardRequest,
  CreatePPTStoryboardResponse,
} from "src/types/experiences/importDesign";

const paperfliteApiUrl = process.env.REACT_APP_API_URL;
const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

export const uploadPPTToS3 = (
  file: File,
  originalName: string,
  onProgress?: (percent: number) => void,
): Promise<{ signedUrl: string }> => {
  return new Promise((resolve, reject) => {
    new S3Upload({
      signingUrl: "/api/2.0/file_upload/initiate",
      signingUrlMethod: "POST",
      signingUrlHeaders: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
      server: paperfliteApiUrl,
      scrubFilename: (filename) =>
        encodeURIComponent(filename.replace(/[^\w\d_\-.\s]+/gi, "")),
      signingUrlQueryParams: { originalName: encodeURIComponent(originalName) },
      contentDisposition: "auto",
      uploadRequestHeaders: {},
      onProgress: (percent) => onProgress?.(percent),
      onFinishS3Put: (signResult) =>
        resolve({ signedUrl: signResult.signedUrl }),
      onError: (err) => reject(err),
      files: [file],
    });
  });
};

export const experiencesImportDesignApi = {
  createStoryboardFromPPT: async (
    request: CreatePPTStoryboardRequest,
  ): Promise<CreatePPTStoryboardResponse> => {
    const response = await axios.post(
      `${cleverstoryApiUrl}/api/2.0/storyboards/ppt`,
      request,
    );
    return response.data;
  },
};
